import axios from "axios";

export const getDataTableTransaksiJurnal = async (
  searchText = null,
  sortingCol = 0,
  offset = 0,
  limit = 0,
  sortingMode = "DESC"
) => {
  if (searchText) {
    return await axios.get(
      `${window._HOST}admin/transaksiJurnal/dataTable?search-text=${searchText}&offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  } else {
    return await axios.get(
      `${window._HOST}admin/transaksiJurnal/dataTable?offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  }
};

export const insertNewTransaksiJurnal = async (formData) => {
  return await axios.post(`${window._HOST}admin/transaksiJurnal/`, formData, {
    withCredentials: true,
  });
};

export const deleteTransaksiJurnal = async (id_transaksi_jurnal) => {
  return await axios.delete(
    `${window._HOST}admin/transaksiJurnal/${id_transaksi_jurnal}`,
    { withCredentials: true }
  );
};

export const importCSVTransaksiJurnal = async (formData) => {
  return await axios.post(
    `${window._HOST}admin/transaksiJurnal/importCSV`,
    formData,
    { withCredentials: true }
  );
};

export const exportSpesifikTransaksiJurnal = async () => {
  return await axios.get(`${window._HOST}/admin/transaksiJurnal/specificData`, {
    withCredentials: true,
  });
};
